<ng-container *ngIf="!collapsed()">
    <a class="side-nav__item" [ngClass]="itemClasses(item())" mat-list-item [routerLink]="item().route" routerLinkActive
        #rla="routerLinkActive" (click)="toggleNestedMenu($event)">
        <div class="side-nav__icon" matListItemIcon>
            <img *ngIf="item().icon" [src]="'../../assets/img/' + item().icon + '.svg'" alt="">
        </div>
        <span matListItemTitle>{{item().label | translate}}</span>
        <img *ngIf="item().subItems" class="side-nav__arrow" src="../../../assets/img/caret-down.svg" alt="" />
        <!-- <i *ngIf="item().subItems" class="fa-solid fa-caret-down side-nav__arrow" style="margin-left:0.5rem;color: var(--font-color) !important;"
            [ngClass]="getArrowClass()" >
        </i> -->
    </a>
    <ng-container *ngIf="item().subItems && nestedMenuOpen()">
        <div>
            @for (subItem of item().subItems; track subItem.label) {
            <side-nav-menu [item]="subItem" [collapsed]="collapsed()" [level]="level() + 1" />
            }
        </div>
    </ng-container>
</ng-container>

<ng-container *ngIf="collapsed()">
    <ng-container *ngIf="!item().subItems;">
        <a class="side-nav__item" [ngClass]="itemClasses(item())" mat-list-item [routerLink]="item().route"
            routerLinkActive #rla="routerLinkActive" [activated]="rla.isActive">
            <div class="side-nav__icon" *ngIf="item().icon" matListItemIcon>
                <img [src]="'../../assets/img/' + item().icon + '.svg'" alt="">
            </div>
        </a>
    </ng-container>
    <ng-container *ngIf="item().subItems;">
        <mat-list-item class="side-nav__item" (click)="trigger.toggleMenu()" [routerLink]="item().route"
            routerLinkActive #rla="routerLinkActive" [ngClass]="itemClasses(item())">
            <div class="side-nav__icon" *ngIf="item().icon" matListItemIcon>
                <img [src]="'../../assets/img/' + item().icon + '.svg'" alt="">
            </div>
            <div [matMenuTriggerFor]="menu" #trigger="matMenuTrigger"></div>
        </mat-list-item>
        <mat-menu #menu="matMenu" class="side-nav__menu-panel">
            <ng-container *ngFor="let subItem of item().subItems;">
                <a mat-menu-item [disableRipple]="true" [routerLink]="subItem.route" routerLinkActive
                    #rla="routerLinkActive" [ngClass]="{ 'side-nav__menu-item--active': isActive(subItem) }">
                    {{subItem.label | translate}}
                </a>
            </ng-container>
        </mat-menu>
    </ng-container>
</ng-container>
